"use client";
import React from "react";
import Grid, { GridProps } from "@mui/material/Grid";

export type WcGridProps = GridProps;

export const WcGrid = ({ children, ...props }: WcGridProps) => (
  <Grid data-testid="grid" {...props}>
    {children}
  </Grid>
);
